// Define the team settings structure
export interface TeamSettings {
  [key: string]: any;
}

// Create a cache with expiry
interface CacheEntry {
  data: TeamSettings;
  timestamp: number;
}

// Cache expiration time (1 hour in milliseconds)
const CACHE_EXPIRY = 60 * 60 * 1000;

// Team settings cache
const teamSettingsCache = new Map<string, CacheEntry>();

/**
 * Set team settings in the cache
 */
export function setTeamSettings(teamId: string, settings: TeamSettings): void {
  if (!teamId) return;
  
  teamSettingsCache.set(teamId, {
    data: settings,
    timestamp: Date.now()
  });
}

/**
 * Get team settings from the cache
 * @returns The team settings or null if not found or expired
 */
export function getTeamSettings(teamId: string): TeamSettings | null {
  if (!teamId) return null;
  
  const entry = teamSettingsCache.get(teamId);
  if (!entry) {
    return null;
  }
  
  // Check if entry has expired
  if (Date.now() - entry.timestamp > CACHE_EXPIRY) {
    teamSettingsCache.delete(teamId);
    return null;
  }
  
  return entry.data;
}

/**
 * Clear the team settings cache
 */
export function clearTeamSettingsCache(): void {
  teamSettingsCache.clear();
} 